import { createReducer, on } from '@ngrx/store';
import {
  PrintSiteRef,
  CustomerType,
  CheckLayout,
} from '../../core/models/reference.model';
import { ReferenceActions, ReferenceAPIActions } from './reference.actions';

export interface ReferenceState {
  printSites: PrintSiteRef[];
  printSitesLoading: boolean;
  printSitesLoaded: boolean;

  customerTypes: CustomerType[];
  customerTypesLoading: boolean;
  customerTypesLoaded: boolean;

  checkLayouts: CheckLayout[];
  checkLayoutsLoading: boolean;
  checkLayoutsLoaded: boolean;

  error: string | null;
}

export const initialState: ReferenceState = {
  printSites: [],
  printSitesLoading: false,
  printSitesLoaded: false,

  customerTypes: [],
  customerTypesLoading: false,
  customerTypesLoaded: false,

  checkLayouts: [],
  checkLayoutsLoading: false,
  checkLayoutsLoaded: false,

  error: null,
};

export const referenceReducer = createReducer(
  initialState,

  // Load All
  on(ReferenceActions.loadAllReferenceData, state => ({
    ...state,
    printSitesLoading: !state.printSitesLoaded,
    customerTypesLoading: !state.customerTypesLoaded,
    checkLayoutsLoading: !state.checkLayoutsLoaded,
    error: null,
  })),

  // Print Sites
  on(ReferenceActions.loadPrintSites, state => ({
    ...state,
    printSitesLoading: true,
  })),

  on(ReferenceAPIActions.loadPrintSitesSuccess, (state, { printSites }) => ({
    ...state,
    printSites,
    printSitesLoading: false,
    printSitesLoaded: true,
  })),

  on(ReferenceAPIActions.loadPrintSitesFailure, (state, { error }) => ({
    ...state,
    printSitesLoading: false,
    error,
  })),

  // Customer Types
  on(ReferenceActions.loadCustomerTypes, state => ({
    ...state,
    customerTypesLoading: true,
  })),

  on(
    ReferenceAPIActions.loadCustomerTypesSuccess,
    (state, { customerTypes }) => ({
      ...state,
      customerTypes,
      customerTypesLoading: false,
      customerTypesLoaded: true,
    })
  ),

  on(ReferenceAPIActions.loadCustomerTypesFailure, (state, { error }) => ({
    ...state,
    customerTypesLoading: false,
    error,
  })),

  // Check Layouts
  on(ReferenceActions.loadCheckLayouts, state => ({
    ...state,
    checkLayoutsLoading: true,
  })),

  on(
    ReferenceAPIActions.loadCheckLayoutsSuccess,
    (state, { checkLayouts }) => ({
      ...state,
      checkLayouts,
      checkLayoutsLoading: false,
      checkLayoutsLoaded: true,
    })
  ),

  on(ReferenceAPIActions.loadCheckLayoutsFailure, (state, { error }) => ({
    ...state,
    checkLayoutsLoading: false,
    error,
  }))
);
